import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      addNotification: 'notification/add',
    }),

    createNotification(type, message) {
      const notification = {
        type,
        message,
      };
      this.addNotification(notification);
    },
  },
};
